import axios from "../config/axios";
import Constants from "../data/Constants";

export const getAllPayrolls = async (filters, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.PAYROLL.ALL, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};

// export const getSingleCourse = async (id) => {
//   return await axios.get(Constants.ENDPOINTS.COURSE.SINGLE + id).then((res) => {
//     return res.data.result;
//   });
// };

// export const createSingleCourse = async (data) => {
//   return await axios
//     .post(Constants.ENDPOINTS.COURSE.CREATE, data)
//     .then((res) => {
//       return res.data.result;
//     });
// };

export const updatePayroll = async (id, data) => {
  return await axios
    .patch(Constants.ENDPOINTS.PAYROLL.UPDATE + id, data)
    .then((res) => {
      return res.data.result;
    });
};

export const createPayroll = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.PAYROLL.CREATE, data)
    .then((res) => {
      return res.data.result;
    });
};
